import * as types from '../mutation-types'
import { API } from '../../api'
import { DONATE_DATA_MANAGER } from '../../data'
import { WEIXIN_PAY } from '../../weixin'

export default {
    namespaced: true,
    state: {
        totalNum: 0,
        myNum: 0,
        productList: [],
        donateSuccess: false
    },
    getters: {},
    mutations: {
    },
    actions: {
        getDonateInfo({ state }) {
            API.getDonateSupport({}, function(data) {
                console.log('获取捐赠加油人数相关信息成功:::::::', data)
                state.totalNum = data.id;
                state.myNum = data.my;
            })
        },
        startSupport({ dispatch, state }, params) {
            console.log('startSupport------', params);
            API.setDonateSupport({}, function(data) {
                // 更新我的名次
                state.myNum = data.id;
                // 刷新加油人数的数据
                dispatch('getDonateInfo');
                // 拉取产品列表
                API.getDonateProductList({}, function(data) {
                    console.log('获取捐赠商品列表成功:::::::', data)
                    state.productList = DONATE_DATA_MANAGER.getProductListByList(data);
                    // 成功后回调
                    if(params.sucCb && typeof(params.sucCb) == 'function') {
                        params.sucCb();
                    }
                })
            })
        },
        setContactMe({ state }, params) {
            API.setContact({
                f_content: params.wechatNo,
                f_type: params.type //1
            }, function(data) {
                // 成功后回调
                if(params.sucCb && typeof(params.sucCb) == 'function') {
                    params.sucCb();
                }
            }, function() {
                // 失败后回调
                if(params.failCb && typeof(params.failCb) == 'function') {
                    params.failCb();
                }
            });
        },
        startDonate({ state }, params) {
            API.createDonateOrder(params.params, function(data) {
                console.log('捐赠付款成功:::::::', data)
                WEIXIN_PAY.createOrder(data.return, function(data) {
                    console.log('clickPay-----支付成功', data)
                    state.donateSuccess = true;
                    if(params.sucCb && typeof(params.sucCb) == 'function') {
                        params.sucCb();
                    }
                }, function(data) {
                    console.log('clickPay-----支付失败', data)
                    if(params.failCb && typeof(params.failCb) == 'function') {
                        params.failCb();
                    }
                })
            }, function() {
                // 失败后回调
                if(params.failCb && typeof(params.failCb) == 'function') {
                    params.failCb();
                }
            })
        },
        resetData({ state }){
            state.totalNum = 0;
            state.myNum = 0;
            state.productList = [];
            state.donateSuccess = false;
        }
    }
}